export const getUrlParams = (urlParams: string): string => {
  if (!urlParams) return "";

  const searchParams = new URLSearchParams(urlParams);
  const params = searchParams ? `?${searchParams.toString()}` : "";

  return params;
};
